import { PaymentMethodEnum } from 'api-hooks/payment-channel';
import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import CashAccountSelectInput from 'legacy-modules/master/cash-account/components/select-input';
import ChequeGiroSelectInput from 'legacy-modules/master/cheque-giro/components/select-input';
import PaymentMethodSelectInput from 'legacy-modules/master/select-input/payment-method-select-input';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';

export default function PaymentField() {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <PaymentMethodSelectInput
            name="paymentMethodId"
            required
            onAfterDetailChange={(values) => {
              setValue('paymentMethodId', values?.id);
              setValue('paymentName', values?.type);
            }}
          />
        </HalfContainer>
        <HalfContainer>
          <HOCInput keys={['paymentName']}>
            {(values) => {
              switch (values.paymentName) {
                case PaymentMethodEnum.Bank:
                  return (
                    <BankAccountSelectInput name="paymentableId" required />
                  );
                case PaymentMethodEnum.ChequeGiro:
                  return (
                    <>
                      <ChequeGiroSelectInput name="paymentableId" required />
                    </>
                  );
                case PaymentMethodEnum.Cash:
                  return (
                    <CashAccountSelectInput name="paymentableId" required />
                  );
                default:
                  return <></>;
              }
            }}
          </HOCInput>
        </HalfContainer>
      </SectionContainer>
      <HOCInput keys={['paymentName']}>
        {(values) => {
          switch (values.paymentName) {
            case PaymentMethodEnum.ChequeGiro:
              return (
                <FullContainer>
                  <SectionContainer>
                    <HalfContainer>
                      <SectionContainer>
                        <HalfContainer>
                          <Input
                            type="text"
                            name="chequeNote.referenceNumber"
                            label={t('debt:reference_number')}
                            placeholder={t('debt:reference_number')}
                            required
                          />
                        </HalfContainer>
                        <HalfContainer>
                          <Input
                            type="date-time"
                            name="chequeNote.issuedAt"
                            label={t('debt:issued_at')}
                            placeholder={t('debt:issued_at')}
                            required
                          />
                        </HalfContainer>
                      </SectionContainer>
                    </HalfContainer>
                    <HalfContainer>
                      <SectionContainer>
                        <HalfContainer>
                          <Input
                            type="date-time"
                            name="chequeNote.availableAt"
                            label={t('debt:available_at')}
                            placeholder={t('debt:available_at')}
                            required
                          />
                        </HalfContainer>
                        <HalfContainer>
                          <Input
                            type="date-time"
                            name="chequeNote.expiredAt"
                            label={t('debt:expiry_at')}
                            placeholder={t('debt:expiry_at')}
                            required
                          />
                        </HalfContainer>
                      </SectionContainer>
                    </HalfContainer>
                  </SectionContainer>

                  <BankAccountSelectInput
                    name="chequeNote.bankAccountId"
                    required
                  />
                </FullContainer>
              );
            default:
              return <></>;
          }
        }}
      </HOCInput>
    </FullContainer>
  );
}
